<template>
  <div class="d-inline-flex align-items-center gap-2">
    <button class="btn btn-sm btn-outline-secondary" type="button" @click="month = month.subtract(1, 'month')">‹</button>
    <span class="month-title text-center">{{ month.format("MMMM YYYY") }}</span>
    <button class="btn btn-sm btn-outline-secondary" type="button" @click="month = month.add(1, 'month')">›</button>
  </div>
</template>

<script setup>
defineOptions({ name: "MonthPicker" })

// dayjs, first day of the month
const month = defineModel({ type: Object, required: true })
</script>

<style scoped>
.month-title {
  min-width: 9rem;
}
</style>
